import * as React from 'react';
import type { Router } from 'react-router';
import { IndexRedirect, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import TeamsApp from 'bundles/teams-v2/components/TeamsApp';
import { isNewCheckoutEnabled } from 'bundles/teams-v2/utils/experimentUtils';

const AccountDetails = loadOnRoute(() => import('bundles/teams-v2/components/AccountDetails'));
const AccountDetailsVerify = loadOnRoute(() => import('bundles/teams-v2/components/AccountDetailsVerify'));
const BillingInfo = loadOnRoute(() => import('bundles/teams-v2/components/BillingInfo'));
const PlanDetails = loadOnRoute(() => import('bundles/teams-v2/components/PlanDetails'));
const PurchaseConfirmation = loadOnRoute(
  () => import('bundles/teams-v2/components/PurchaseConfirmation/PurchaseConfirmationRouter')
);
const InvoiceConfirmation = loadOnRoute(() => import('bundles/teams-v2/components/InvoiceConfirmation'));

const requireRedirect: Router.EnterHook = (nextState, replace) => {
  const isNewCheckout = isNewCheckoutEnabled();
  if (!isNewCheckout) return;
  const currentQuery = nextState.location.query || {};

  // if not learnerCount, make it 5
  if (!currentQuery.learnerCount) {
    currentQuery.learnerCount = 5;
  }

  // if not billingType, make it 1
  if (!currentQuery.billingType) {
    currentQuery.billingType = 1;
  }

  if (currentQuery && 'thirdPartyOrganizationId' in currentQuery) {
    currentQuery.thirdPartyOrganizationId = currentQuery.thirdPartyOrganizationId;
    replace({
      pathname: '/purchase/billing',
      query: currentQuery,
    });
    return;
  }

  replace({
    pathname: '/purchase/account',
    query: currentQuery,
  });
};

export default (
  <Route path="/">
    <Route path="purchase" component={TeamsApp}>
      <Route path="plan" onEnter={requireRedirect} getComponent={PlanDetails} />
      <Route path="account" getComponent={AccountDetails} />
      <Route path="verify" getComponent={AccountDetailsVerify} />
      <Route path="billing" getComponent={BillingInfo} />
      <Route path="invoice-confirmation" getComponent={InvoiceConfirmation} />
      <Route path="confirmation" getComponent={PurchaseConfirmation} />
      <Route path="*" component={NotFound} />
      <IndexRedirect to="/purchase/plan" />
    </Route>
  </Route>
);
